<script>
    import {handleScoopAjaxError} from '../../../vendor/rmts/scoop-os/resources/js/mixins/axios-response-errors'
    import _ from "lodash";

    export default {
        props: {
            languages: Array,
            total: String,
            filter: null,
            selectedRows: Array,
            filterType: String,
            canCreateTranslationExport: {
              type: Boolean,
              default: false,
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                selectedModels: Scoop.selectedModels.state,
                selectedLanguageId: null,
                loading: false,
                csrf: Scoop.csrfToken,
                selectedExportVariant: 'standard',
                exportVariants: [
                  {
                    title: 'Standard',
                    value: 'standard',
                    canSee: true,
                  },
                  {
                    title: 'KI-Übersetzung',
                    value: 'ai',
                    canSee: this.canCreateTranslationExport,
                  }
                ],
              confirmAiTranslation: false,
              cancelTokenChars: null,
              charactersCount: 0,
              loadingChars: false,
              productNumbers: []
            }
        },
        created() {
            this.selectedLanguageId = this.languages[0]['id'];
        },
        watch: {
          selectedProducts: function () {
            this.calcCharactersCount();
          },
          selectedExportVariant: function () {
            this.calcCharactersCount();
          }
        },
        computed: {
            route() {
                return this.baseUrl + '/productTextsExport';
            },
            selectedProducts() {
                return this.selectedModels['products'];
            },
            selectedLanguage() {
                return this.languages.find(element => {
                    return element.id == this.selectedLanguageId
                }).language_name
            },
            subheadline() {
                if (!this.selectedProducts || this.selectedProducts.length === 0) {
                    return this.total + ' Artikel im Filter';
                }

                return this.total + ' Artikel im Filter, ' + this.selectedProducts.length + ' Artikel selektiert';
            },
            submitIsDisabled() {
                if(this.loading) {
                    return true;
                }

                if(this.selectedExportVariant === 'standard') {
                    return false;
                }

                if(this.selectedExportVariant === 'ai' && this.loadingChars === true) {
                  return true;
                }

                if(this.selectedExportVariant === 'ai' && this.productNumbers.length === 0) {
                  return true;
                }

                return this.selectedExportVariant === 'ai' && this.confirmAiTranslation === false;


            },
            totalarticles() {
                if (!this.selectedProducts || this.selectedProducts.length === 0) {
                    return this.total;
                } else {
                    return this.selectedProducts.length;
                }
            }
        },
        methods: {
            exportTexts() {
              if(this.selectedExportVariant === 'ai') {
                this.startAiExport();
                return;
              }

                this.loading = true;
                toastr.success('Export wird gestartet...', this.totalarticles + ' Artikel / ' + this.selectedLanguage);
                axios.get(this.route, {
                    params: {
                        selectedLanguageId: this.selectedLanguageId,
                        filterType: this.filterType,
                    }
                })
                    .then((response) => {
                        toastr.success('Export wurde generiert!');
                        this.loading = false;
                        $('#textExport').modal('hide');
                        window.location.href = this.route + '/' + response.data.filename;
                    }).catch(error => {
                    handleScoopAjaxError(error, 'Export konnte nicht generiert werden!');
                    this.loading = false;
                });
            },
            startAiExport: function () {
              if (confirm('Sind Sie sich absolut sicher, dass Sie den Export starten möchten? Der Export ist mit Kosten verbunden.')) {
                axios.put('/auto-translation', {
                  language_id: this.selectedLanguageId,
                  product_numbers: this.productNumbers,
                }).then(function () {
                  toastr.success('Export wurde gestartet');

                  setTimeout(function () {
                    window.location.href = '/auto-translation';
                  }, 1000);

                }.bind(this)).catch(function (error) {
                  handleScoopAjaxError(error, 'Export konnte nicht gestartet werden!');
                })
              }
            },
            calcCharactersCount: _.debounce(function () {
              if(this.selectedExportVariant !== 'ai') {
                return;
              }

              if (this.cancelTokenChars) {
                this.loadingChars = false;
                this.cancelTokenChars.cancel('Request canceled due to new request.');
              }

              this.loadingChars = true;
              this.cancelTokenChars = axios.CancelToken.source();

              axios.post('/auto-translation/characters-count', {
                product_ids: this.selectedProducts,
                filterType: this.filterType,
              }, {
                cancelToken: this.cancelTokenChars.token
              }).then(function (response) {
                this.loadingChars = false;
                this.charactersCount = response.data.chars;
                this.productNumbers = response.data.product_numbers;
              }.bind(this)).catch(function (error) {
                this.loadingChars = false;
                if (!axios.isCancel(error)) {
                  handleScoopAjaxError(error, 'Fehler beim Berechnen der Zeichenanzahl!');
                }
              }.bind(this));
            }, 500),
          onLightboxClosing: function () {
            this.loadingChars = false;
            this.cancelTokenChars.cancel('Request canceled due to closing lightbox.');
            this.selectedExportVariant = 'standard';
            this.confirmAiTranslation = false;
          }
        }
    }
</script>

<template>
    <div>
        <Lightbox
                id="textExport"
                @lightboxopening="calcCharactersCount"
                @lightboxclosing="onLightboxClosing"
                isOoen=""
                headline="Export Texte für Übersetzung"
                :subheadline="subheadline"
                :large="true">
            <button slot="open-template" class="btn btn-sm btn-default m-t-md">
                <i class="fa fa-download"></i>
                <span>Export Texte für Übersetzung</span>
            </button>
            <div slot="body" class="row">
              <div class="col-sm-12">
                <label class="col-sm-2 control-label lh-34">Export-Variante</label>
                <div class="col-sm-10">
                  <select class="form-control m-b" name="selectedExportVariant" v-model="selectedExportVariant">
                    <option v-for="(variant, idx) in exportVariants.filter((item) => item.canSee)" :key="idx" :value="variant.value" :selected="variant.value === selectedExportVariant">
                      {{variant.title}}
                    </option>
                  </select>
                </div>
              </div>
                <div class="col-sm-12">
                    <label class="col-sm-2 control-label lh-34">Sprache</label>
                    <div class="col-sm-10">
                        <select class="form-control m-b" name="selectedLanguageId" v-model="selectedLanguageId">
                            <option v-for="language in languages" :value="language.id"
                                    :selected="language.id === selectedLanguageId">
                                {{ language.language_name }}
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-sm-12">
                <div>
                <div class="col-sm-2"></div>
                <div class="col-sm-10">
                  <div class="m-t-md">
                    <h4>Export-Informationen:</h4>
                    <p v-if="selectedExportVariant === 'standard'">
                      - Exportiert werden alle Texte der ausgewählten Artikel in der gewählten Sprache. Die Datei ist sofort verfügbar und kann im <a
                        href="/auto-translation/import">Import</a> verwendet werden
                    </p>
                    <p v-else-if="selectedExportVariant === 'ai'">
                      - Alle Texte der ausgewählten Artikel werden zur gewählten Sprache mit KI übersetzt.
                      <br />
                      - Die Datei wird im Hintergrund generiert und kann nach Abschluss unter <a
                        href="/auto-translation">KI-Übersetzung</a> eingesehen werden.
                      <br />
                      - Der gewünschte Exporte kann dort heruntergeladen werden und und unter <a href="/auto-translation/import">Import</a> verwendet werden.
                      <br />
                      - Die Ki-Übersetzung ist mit Kosten verbunden.
                    </p>
                  </div>
                </div>
                </div>
                <div v-if="selectedExportVariant === 'ai'">
                <div class="col-sm-2"></div>
                <div class="col-sm-10">
                  <h4>Kosten</h4>
                  <div class="form-group">
                    <p>Die Kosten können von Sprache zu Sprache variieren.</p>
                    <p :key="charactersCount">Anzahl Zeichen: <strong v-if="loadingChars">Berechnung läuft</strong><strong v-else>{{ Number(charactersCount ?? 0).toLocaleString('de-DE') ?? 0 }}</strong></p>
                  </div>
                </div>
                  <div class="col-sm-2"></div>
                  <div class="col-sm-10">
                    <h4>Bestätigen</h4>
                    <div class="checkbox m-b-none m-t-none">
                      <label>
                        <input type="checkbox" value="confirm" v-model="confirmAiTranslation">
                        <span>Mir ist bewusst, dass die KI-Übersetzung mit Kosten verbunden ist.</span>
                      </label>
                      <br> <br>
                    </div>
                  </div>
                </div>
              </div>
                <div class="hr-line-dashed col-sm-12 m-t-xs m-b-sm"></div>
                <div v-show="loading" class="text-center">
                    <i class="fa fa-2x fa-cog fa-spin"></i>
                </div>
            </div>
            <div v-cloak slot="footer">
                <button class="btn btn-white pull-left" data-dismiss="modal"
                        style="margin-bottom: 0">Abbrechen
                </button>
                <div role="group" class="btn-group">
                    <div role="group" class="btn-group">
                        <button class="btn btn-primary btn-sm" data-dismiss="modal" @click="exportTexts"
                                :disabled='submitIsDisabled'>
                            <span class="m-r-sm">Exportieren</span>
                            <i class="fa fa-download"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Lightbox>
    </div>
</template>